var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionRulerUnit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2v13h9V2H3Zm7 2H5v9h5v-1H8v-2h2V8H8V6h2V4Z",
    clipRule: "evenodd",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 13v9H3v-9h18Zm-2 2v5H5v-5h2v2h2v-2h2v2h2v-2h2v2h2v-2h2Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionRulerUnit);
export default __webpack_public_path__ + "static/media/ic_action_ruler_unit.41cf531864d667825061a4c74ccaab3c.svg";
export { ForwardRef as ReactComponent };